module.exports = __webpack_public_path__ + "img/horizontal_3_7_9016.cd492e3a.png";